import React from 'react';

const Ecosystem = () => {
  // "Built Around the Life of Your Pet" heading and card set removed per design update.
  // Section anchor preserved for navigation.
  return <div id="ecosystem" />;
};

export default Ecosystem;
